import { useQuery, useQueryClient } from "@tanstack/react-query";

import { notificationSettingQueryKeys } from "./query-keys";
import { notificationsUrl } from "../constants";
import { notificationSettingsResponseSchema } from "../schemas";

import { instance } from "@/lib/axios/instance";

export function useNotificationSettings() {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: notificationSettingQueryKeys.list(),
    queryFn: async () => {
      const { data } = await instance.get<unknown>(notificationsUrl("Settings"));
      return notificationSettingsResponseSchema.parse(data);
    },
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: () =>
      queryClient.isMutating({ mutationKey: notificationSettingQueryKeys.updates() }) === 0,
  });
}
